@let _totalPages = totalPages();
@let _page = page();
@let _isFirstPage = isFirstPage();
@let _isLastPage = isLastPage();
@let _loading = loading();

<div class="lg-paginator">
    <button
        type="button"
        class="lg-paginator__button"
        [disabled]="_isFirstPage || _loading"
        (click)="goToFirstPage()"
        aria-label="First page"
    >
        <lg-icon icon="icon-chevron-first" [width]="20" [height]="20" />
    </button>

    <button
        type="button"
        class="lg-paginator__button"
        [disabled]="_isFirstPage || _loading"
        (click)="goToPreviousPage()"
        aria-label="Previous page"
    >
        <lg-icon icon="icon-arrow-left" [width]="20" [height]="20" />
    </button>

    <div class="lg-paginator__page-selector">
        @if (useInputField()) {
            <input
                type="number"
                class="lg-paginator__input"
                [value]="_page + 1"
                [min]="1"
                [max]="_totalPages"
                [disabled]="_loading"
                (keydown.enter)="onPageInputEnter($event)"
                (blur)="onPageInputBlur($event)"
                aria-label="Page number"
            />
        } @else {
            <select
                class="lg-paginator__select"
                [value]="_page + 1"
                [disabled]="_loading"
                (change)="onPageSelectChange($event)"
                aria-label="Select page"
            >
                @for (pageNum of pageNumbers(); track pageNum) {
                    <option [value]="pageNum">{{ pageNum }}</option>
                }
            </select>
        }
        <span class="lg-paginator__page-info">{{
            "FW._Directives.Paginator_OfPages" | lgTranslate: { totalPages: _totalPages }
        }}</span>
    </div>

    <button
        type="button"
        class="lg-paginator__button"
        [disabled]="_isLastPage || _loading"
        (click)="goToNextPage()"
        aria-label="Next page"
    >
        <lg-icon icon="icon-arrow-right" [width]="20" [height]="20" />
    </button>

    <button
        type="button"
        class="lg-paginator__button"
        [disabled]="_isLastPage || _loading"
        (click)="goToLastPage()"
        aria-label="Last page"
    >
        <lg-icon icon="icon-chevron-last" [width]="20" [height]="20" />
    </button>
</div>
